import React, { useEffect, useRef } from "react"; // Import useEffect and useRef
import { Save, Edit, ArrowLeft } from "lucide-react";

const StepTwo = ({
  selectedHospital,
  selectedTopic,
  isNewTopic,
  testName,
  setTestName,
  editingTestId,
  isEditingTitle,
  editedTestName,
  setEditedTestName,
  handleEditTestName,
  handleSaveTestName,
  handleCancelEditName,
  isLoading,
  handlePreviousStep,
  handleNextStep
}) => {
  const testNameInputRef = useRef(null); // Create a ref for the test name input

  useEffect(() => {
    // If we are not editing an existing test (i.e., creating a new one)
    // and the input ref is available, focus the input.
    // This will happen when transitioning from Step 1 to Step 2 for a new test.
    if (!editingTestId && testNameInputRef.current) {
      testNameInputRef.current.focus();
    }
  }, [editingTestId]); 

  return (
    <div className="training-step-content">
      <div className="training-selection-summary">
        בית חולים: {selectedHospital ? selectedHospital.nameHebrew : ''} | 
        נושא {isNewTopic ? 'חדש' : 'המבחן'}: {selectedTopic ? selectedTopic.name : ''}
      </div>
      
      <div className="training-select-field">
        <div className="training-field-label">שם המבחן</div>
        {!!editingTestId && isEditingTitle ? (
          <div className="training-test-name-edit-container">
            <input
              type="text"
              className="training-text-input"
              placeholder="הכנס שם למבחן"
              value={editedTestName}
              onChange={(e) => setEditedTestName(e.target.value)}
              // autoFocus // Optionally, you could autofocus this if isEditingTitle becomes true
            />
            <div className="training-test-name-actions">
              <button 
                className="training-button training-button-primary training-button-small"
                onClick={handleSaveTestName}
                disabled={isLoading}
              >
                <Save size={16} />
                שמור
              </button>
              <button 
                className="training-button training-button-secondary training-button-small"
                onClick={handleCancelEditName}
                disabled={isLoading}
              >
                ביטול
              </button>
            </div>
          </div>
        ) : (
          <div className="training-test-name-display">
            {!!editingTestId && (
              <button 
                className="training-button training-button-secondary training-button-small"
                onClick={handleEditTestName}
                title="ערוך שם מבחן"
                type="button"
              >
                <Edit size={16} />
                <span className="button-text">ערוך שם</span>
              </button>
            )}
            <input
              ref={testNameInputRef} // Assign the ref to the input
              type="text"
              className="training-text-input"
              placeholder="הכנס שם למבחן"
              value={testName}
              onChange={(e) => setTestName(e.target.value)}
              disabled={!!editingTestId} // Input is disabled if editing an existing test (not its title)
            />
          </div>
        )}
      </div>
      
      <div className="training-buttons-container">
        <button 
          className="training-button training-button-secondary"
          onClick={handlePreviousStep}
        >
          חזרה
        </button>
        <button 
          className="training-button training-button-primary"
          onClick={handleNextStep}
          disabled={!testName.trim() || (!!editingTestId && isEditingTitle)} // ensure disabled correctly if editing title of existing test
        >
          המשך
          <ArrowLeft size={16} />
        </button>
      </div>
    </div>
  );
};

export default StepTwo;